import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bc86161"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "middle payment" }

import { onMounted, ref, Ref } from "vue";
import SuccessPayment from "@/components/payment/SuccessPayment.vue";
import { Transaction, TransactionStatus, useEsimStore } from "@/stores/esim";
import EsimErrorPayment from "@/components/payment/EsimErrorPayment.vue";
import FailPayment from "@/components/payment/FailPayment.vue";
import WaitPayment from "@/components/payment/WaitPayment.vue";
import router from "@/router";
import { useGtm } from "@gtm-support/vue-gtm";


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentView',
  props: {
  id: String,
},
  setup(__props) {

const props = __props;

const checkInterval: Ref<number> = ref(0);
const esimStore = useEsimStore();
const transaction: Ref<Transaction | undefined> = ref();

async function checkTransaction(): Promise<void> {
  const transactionId: number | undefined = parseInt(String(props.id));
  if (!transactionId) return;

  transaction.value = await esimStore.getTransaction(transactionId);
  if (!transaction.value) {
    stopCheckInterval();
    await router.push("/");
    return;
  }

  if (
    transaction.value &&
    transaction.value.status === TransactionStatus.payed
  ) {
    try {
      // eslint-disable-next-line no-undef
      gtag("event", "purchase", {
        transaction_id: transaction.value.id,
        value: transaction.value.amount / 100,
        tax: transaction.value.tax,
        currency: "USD",
        coupon: "SUMMER_SALE",
        items: [
          {
            item_id: transaction.value.bundleSubId,
            item_name: transaction.value.productName,
            price: transaction.value.amount / 100,
            quantity: 1,
          },
        ],
      });

      // eslint-disable-next-line no-undef
      fbq("track", "Purchase", {
        value: transaction.value.amount / 100,
        currency: "USD",
        contents: [
          {
            id: transaction.value.bundleSubId,
            quantity: 1,
          },
        ],
        content_name: transaction.value.productName,
      });
    } catch (e) {
      console.log(e);
    }
  }

  if (transaction.value.status !== TransactionStatus.created) {
    stopCheckInterval();
    return;
  }
}

function startCheckInterval(): void {
  stopCheckInterval();
  checkInterval.value = setInterval(checkTransaction, 5000);
}

function stopCheckInterval(): void {
  clearInterval(checkInterval.value);
  checkInterval.value = 0;
}

onMounted(() => {
  checkTransaction();
  startCheckInterval();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (transaction.value?.status === _unref(TransactionStatus).payed)
      ? (_openBlock(), _createBlock(SuccessPayment, {
          key: 0,
          transaction: transaction.value
        }, null, 8, ["transaction"]))
      : (transaction.value?.status === _unref(TransactionStatus).payedWithSimFail)
        ? (_openBlock(), _createBlock(EsimErrorPayment, { key: 1 }))
        : (transaction.value?.status === _unref(TransactionStatus).failed)
          ? (_openBlock(), _createBlock(FailPayment, { key: 2 }))
          : (_openBlock(), _createBlock(WaitPayment, { key: 3 }))
  ]))
}
}

})